export const EMAIL_DEFAULT = `it-support-sg@schaeffler.com`;
export const EMAIL_CDBA = `OR-HZA-CDBA@schaeffler.com`;
